/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    object, bool, func, string, shape,
} from 'prop-types';
import { connect } from 'react-redux';

import GraphqlPortalLoader from '../../../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlPortalLoader';
import GraphqlCalendarContainer from '../../../../../../components/GraphqlComponents/GraphqlProductPage/Partials/GraphqlPDPCalendar/GraphqlCalendarContainer';
import DeliveryCalendarContainer from '../DeliveryCalendarContainer/DeliveryCalendarContainer';

import { calendarMapPresentation } from '../Helpers/Sku-helper';
import { getFeatureFlags } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';
import CalendarNotAvailableModal from '../CalendarNotAvailableModal/CalendarNotAvailableModal';
import DeliveryCalendarSFContainer from '../DeliveryCalendarContainer/DeliveryCalendarSFContainer';

/**
 * CalendarVariation is used to display different variation of the calendar
 * based on the brand the product belong to - food / floral
 * GraphqlCalendarContainer - floral calendar
 * DeliveryCalendarContainer - food calendar
 */
const CalendarVariation = ({
    openCalendar,
    deliveryDate,
    deliveryTextData,
    orderDetails,
    zipCode,
    handleDeliveryCalendarClose,
    pageProcess,
    featureFlags,
    contextUserState,
    itemRecipientData,
    ldClient,
}) => {
    const [isCalendarLoading, setCalendarDataLoading] = useState(true);
    const [deliveryNotAvailable, handleDeliveryNotAvailability] = useState(false);

    const isStandaloneCard = orderDetails?.itemInfo?.lineItemType === 'GREETINGCARD-ITEM';
    const calendarPresentationFamily = calendarMapPresentation[orderDetails?.product?.brandCode || '1001'] || 'flower';

    const setCalendarDataLoadingFlag = (loading) => {
        setCalendarDataLoading(loading);
    };

    const handleDeliveryAvailabilityFlag = (availablity) => {
        handleDeliveryNotAvailability(!availablity);
        setCalendarDataLoading(false);
    };

    const closeCalendar = () => {
        setCalendarDataLoadingFlag(true);
        handleDeliveryCalendarClose();
    };

    const handleDeliveryNotAvailable = (boolean) => {
        handleDeliveryNotAvailability(boolean);
    };

    return (
        <>
            {featureFlags['which-calendar-variation'] !== 'none'
            && (
                <>
                    {
                        calendarPresentationFamily === 'food'
                        && !isStandaloneCard
                        && (
                            <DeliveryCalendarSFContainer
                                render={({ userGroup }) => (
                                    <>
                                        <DeliveryCalendarContainer
                                            deliveryDate={deliveryDate}
                                            deliveryCalOpen={openCalendar}
                                            pageProcess={pageProcess}
                                            deliveryTextData={deliveryTextData}
                                            orderItem={orderDetails}
                                            handleDeliveryCalendarOpenClose={closeCalendar}
                                            zipCode={zipCode}
                                            // for deliveryCalendarV2
                                            close={closeCalendar}
                                            isOpen={openCalendar}
                                            selectedItemId={orderDetails?.product?.productCode}
                                            productDeliveryType={orderDetails?.product?.productType}
                                            setCalendarDataLoadingFlag={setCalendarDataLoadingFlag}
                                            handleDeliveryAvailability={handleDeliveryAvailabilityFlag}
                                            orderItemId={orderDetails.cartItemId}
                                            brandId={orderDetails?.product?.brandCode}
                                            pageType={pageProcess}
                                            sympathyValue={orderDetails?.product?.sympathyValue || ''}
                                            partNumber=""
                                            ageDetails={{}}
                                            subscriptionTypeAttribute={orderDetails?.subscription?.type || ''}
                                            locationType={orderDetails?.deliveryInfo?.locationType || 'Residence'}
                                            recipientState={itemRecipientData?.state || contextUserState} // we need state to render weather banner based on state
                                            ldClient={ldClient}
                                            openCalendar={openCalendar}
                                            isCalendarLoading={isCalendarLoading}
                                            deliveryNotAvailable={deliveryNotAvailable}
                                            featureFlags={featureFlags}
                                            handleDeliveryCalendarClose={handleDeliveryCalendarClose}
                                            handleDeliveryNotAvailable={handleDeliveryNotAvailable}
                                            userGroup={userGroup}
                                        />
                                    </>
                                )}
                            />
                        )
                    }
                    {
                        (
                            calendarPresentationFamily === 'flower'
                            || isStandaloneCard
                        )  && (
                            <>
                                {(openCalendar && isCalendarLoading) ? <GraphqlPortalLoader /> : null }
                                <GraphqlCalendarContainer
                                    close={closeCalendar}
                                    isOpen={openCalendar}
                                    selectedItemId={orderDetails?.product?.productCode}
                                    productDeliveryType={orderDetails?.product?.productType}
                                    setCalendarDataLoadingFlag={setCalendarDataLoadingFlag}
                                    handleDeliveryAvailability={handleDeliveryAvailabilityFlag}
                                    orderItemId={orderDetails.cartItemId}
                                    brandId={orderDetails?.product?.brandCode}
                                    pageType={pageProcess}
                                    sympathyValue={orderDetails?.product?.sympathyValue || ''}
                                    partNumber=""
                                    ageDetails={{}}
                                    zipCode={zipCode}
                                    subscriptionTypeAttribute={orderDetails?.subscription?.type || ''}
                                    locationType={orderDetails?.deliveryInfo?.locationType || 'Residence'}
                                    recipientState={itemRecipientData?.state || contextUserState} // we need state to render weather banner based on state
                                    ldClient={ldClient}
                                />
                                {deliveryNotAvailable && (
                                    <CalendarNotAvailableModal
                                        isOpen={deliveryNotAvailable}
                                        onClose={() => {
                                            handleDeliveryNotAvailability(false);
                                            handleDeliveryCalendarClose();
                                        }}
                                    />
                                )}
                            </>
                        )
                    }
                </>
            )}
        </>
    );
};

CalendarVariation.propTypes = {
    openCalendar: bool.isRequired,
    deliveryDate: string,
    deliveryTextData: shape({
        deliveryHeaderTitle: string,
        deliveryHeaderCaption: string,
    }),
    orderDetails: object.isRequired,
    zipCode: string,
    handleDeliveryCalendarClose: func.isRequired,
    pageProcess: string.isRequired,
    featureFlags: object.isRequired,
    contextUserState: string,
    itemRecipientData: object,
    ldClient: object,
};

CalendarVariation.defaultProps = {
    deliveryTextData: {
        deliveryHeaderTitle: '',
        deliveryHeaderCaption: '',
    },
    zipCode: '',
    deliveryDate: '',
    contextUserState: '',
    itemRecipientData: {},
    ldClient: null,
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});

export default connect(mapStateToProps)(CalendarVariation);
